import { render, staticRenderFns } from "./message-transfer-with-desc.vue?vue&type=template&id=502cc174&scoped=true"
import script from "./message-transfer-with-desc.vue?vue&type=script&lang=ts"
export * from "./message-transfer-with-desc.vue?vue&type=script&lang=ts"
import style0 from "./message-transfer-with-desc.vue?vue&type=style&index=0&id=502cc174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cc174",
  null
  
)

export default component.exports